module.exports = __webpack_public_path__ + "static/media/fp_chart.260ec6c3.png";